import React, { FC, useEffect, useState, memo } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { FormFieldProps } from 'src/components/Form';
import ProductListTable from './ProductListTable';
import ProductSearchBar from './ProductSearchBar';
import { ProductByGlobalPlanId } from 'src/views/productGroups/hooks/useProducts';
import {
  addStyles,
  AddStyle,
  ShowRadioGroup,
} from 'src/views/customerGroups/CustomerGroupDetails/members/AddMembersForm/CustomerGroupMembersInput';

const AddProductsInput: FC<FormFieldProps<any>> = ({
  error,
  helperText,
  name,
  onChange,
}) => {
  const [addStyle, setAddStyle] = useState<AddStyle>(addStyles.search);
  const [products, setProducts] = useState<ProductByGlobalPlanId[]>([]);

  useEffect(
    () =>
      onChange(
        new CustomEvent('onChange', {
          detail: { name, value: products },
        })
      ),
    [products] // eslint-disable-line react-hooks/exhaustive-deps
  );

  return (
    <Stack height="100%" overflow="hidden">
      <ShowRadioGroup
        addStyle={addStyle}
        isProductGroups={true}
        setAddStyle={setAddStyle}
      />
      <Box sx={(theme) => ({ marginBottom: theme.spacing(3) })}>
        {addStyle === addStyles.search && (
          <ProductSearchBar onSelected={setProducts} />
        )}
      </Box>
      <ProductListTable error={error} helperText={helperText} rows={products} />
    </Stack>
  );
};

export default memo(AddProductsInput);
